export default {
  title: 'Validation',
  validated: 'Your account has been validated',
  connection: 'You can now connect to your account',
  submit: 'Log in'
}
